import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import styled from 'styled-components';

import Lottie from 'react-lottie-player'

import useDimensions from "react-cool-dimensions";

import lottieJson from '../../assets/lottie/loader_lottie.json'

export default function LottieLoader(props) {
    const {
        json = lottieJson
    } = props;

    const {observe, unobserve, width, height, entry} = useDimensions({
        onResize: ({observe, unobserve, width, height, entry}) => {

        }
    });

    return (
        <Wrapper ref={observe}>
            <Lottie
                loop
                animationData={json}
                play
                style={{width: width * 0.7, height: height * 0.7}}
            />
        </Wrapper>
    );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;